import { render, staticRenderFns } from "./CombinationCreate.vue?vue&type=template&id=63de8a80"
import script from "./CombinationCreate.vue?vue&type=script&lang=js"
export * from "./CombinationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports